import React, { memo, useCallback } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { useTranslation } from 'react-i18next'
import classes from './SubTitle.module.scss'

const SectionSubTitle = (
  {
    item,
    variant,
    spacing,
    position,
    className,
    shouldntTranslate,
  },
) => {
  const { t } = useTranslation('common_volunteering')
  const memoT = useCallback((val) => t(val), [t])

  return (
    <h2 className={clsx(classes.title, classes[position], classes[spacing], classes[variant], className || ' ')}>
      {shouldntTranslate ? item : memoT(item)}
    </h2>
  )
}


SectionSubTitle.propTypes = {
  item: PropTypes.string,
  variant: PropTypes.oneOf(['main', 'white']),
  spacing: PropTypes.oneOf(['mb-12', 'mb-4', 'my-12']),
  position: PropTypes.oneOf(['text-start', 'text-center']),
}

SectionSubTitle.defaultProps = {
  item: 'Section subtitle',
  variant: 'main',
  spacing: 'mb-12',
  position: 'text-center',
}

export default memo(SectionSubTitle)
